export enum WorkflowType {
  RUN_TOTALS = 'Run Totals',
  LINK_ALLOCATIONS = 'Link Allocations'
}

export interface WorkflowEvent {
  id: string;
  sync_trigger: string;
  current_stage: string;
  completed_stages: string[];
  status: string;
  createdAt: string;
  updatedAt: string;
  workflow_type: WorkflowType;
}
